import React, {FC, useMemo, useState} from 'react';

import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {SelectAllJobModel} from '../../../../models/api/jobModel';
import {SelectAllBannerContainer} from './selectAllBannerContainer';

/*
 * Props.
 */

interface SelectAllBannersProps {
  jobs: ReadonlyArray<SelectAllJobModel>;
  onStopClick: HandlerOf<number>;
}

/*
 * Component.
 */

export const SelectAllBanners: FC<SelectAllBannersProps> = ({jobs, onStopClick}) => {
  const [dismissedJobIds, setDismissedJobIds] = useState<ReadonlyArray<number>>([]);

  /*
   * Event handlers.
   */

  const onBannerRequestClose = (jobId: number) => {
    setDismissedJobIds((jobIds) => [...jobIds, jobId]);
  };

  /*
   * Render.
   */

  const visibleJobs = useMemo(
    () => jobs.filter((j) => !dismissedJobIds.includes(j.id)),
    [jobs, dismissedJobIds],
  );

  const visibleJobRenders = visibleJobs.map((job) => (
    <SelectAllBannerContainer
      key={job.id}
      job={job}
      onDismissClick={() => onBannerRequestClose(job.id)}
      onStopClick={() => {
        onStopClick(job.id);
        onBannerRequestClose(job.id);
      }}
    />
  ));

  return <>{visibleJobRenders}</>;
};
